import React from 'react';
import DisplayForRole from 'shared/components/misc/displayForRole.jsx';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';

// eslint-disable-next-line react/prop-types, no-unused-vars
const TrackButton = ({ teamId, eventId, rowIndex }) => {
  return (
    <DisplayForRole role={['Event', 'ShowCaller']} scope={{ event: eventId }}>
      <div
        onClick={() => {
          CuesheetRowActions.trackRow(rowIndex);
        }}
        className="cs-row-track-button"
      >
        Track
      </div>
    </DisplayForRole>
  );
};

export default TrackButton;
